export default __webpack_public_path__ + "static/tile-overview-light-6c48bd6c2b2703c36468039bc89a026d.png";